import React, { Fragment } from "react";
import { SidebarMenu } from "./SidebarMenu";
import { typeSidebarData } from "./constants";
import { SkeletonMenu } from "./SkeletonMenu";
import { SidebarLogout } from "./SidebarLogut";
import { XIcon } from "@heroicons/react/outline";
import { Dialog, Transition } from "@headlessui/react";
import LogoSKapps from "../../../../images/logo/logo-SKapps.svg";
import { USERPOSITIONS } from "../../../../constants/userPositions";
import LogoDefault from "../../../../images/logo/era-logo-white.svg";

export type typeSidebarView = {
  sidebarOpen: boolean;
  menuObject: typeSidebarData;
  position: USERPOSITIONS | undefined;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClickMenu: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  setMenuObject: React.Dispatch<React.SetStateAction<typeSidebarData>>;
};

export const ViewComponent: React.FC<typeSidebarView> = ({
  position,
  menuObject,
  sidebarOpen,
  onClickMenu,
  setMenuObject,
  setSidebarOpen,
}) => {
  let Logo = LogoDefault;

  if (
    process.env.REACT_APP_CUSTOMER === "SKAPPS" ||
    process.env.REACT_APP_CUSTOMER === "SKAPPSK"
  )
    Logo = LogoSKapps;

  return (
    <>
      {/* Mobile menu */}
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          static
          open={sidebarOpen}
          onClose={setSidebarOpen}
          className="fixed inset-0 flex z-40 xl:hidden print:hidden"
        >
          <Transition.Child
            as={Fragment}
            leaveTo="opacity-0"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leaveFrom="opacity-100"
            enter="transition-opacity ease-linear duration-300"
            leave="transition-opacity ease-linear duration-300"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-700 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enterTo="translate-x-0"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
            enterFrom="-translate-x-full"
            enter="transition ease-in-out duration-300 transform"
            leave="transition ease-in-out duration-300 transform"
          >
            <div className="relative flex-1 flex flex-col max-w-xs w-full bg-primary-800">
              <Transition.Child
                as={Fragment}
                leaveTo="opacity-0"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leaveFrom="opacity-100"
                leave="ease-in-out duration-300"
                enter="ease-in-out duration-300"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    onClick={() => setSidebarOpen(false)}
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>

              <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                <div className="flex-shrink-0 flex items-center px-4">
                  <img className="h-8 w-auto" src={Logo} alt="Workflow" />
                </div>
                <nav className="mt-5 px-2 space-y-1">
                  {position ? (
                    <SidebarMenu
                      data={menuObject}
                      onClick={(e) => {
                        onClickMenu(e);
                        setSidebarOpen(false);
                      }}
                    />
                  ) : (
                    <SkeletonMenu />
                  )}
                </nav>
              </div>

              <SidebarLogout
                menuObject={menuObject}
                setMenuObject={setMenuObject}
              />
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14" />
        </Dialog>
      </Transition.Root>

      {/* Desktop menu */}
      <div className="hidden xl:flex xl:flex-shrink-0 sidebar-static">
        <div className="flex flex-col w-64">
          <div className="flex flex-col h-0 flex-1 bg-primary-800">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <div className="flex items-center flex-shrink-0 px-4">
                <img className="h-8 w-auto" src={Logo} alt="Logo" />
              </div>
              <nav className="mt-5 flex-1 px-2 bg-primary-800 space-y-1">
                {position ? (
                  <SidebarMenu data={menuObject} onClick={onClickMenu} />
                ) : (
                  <SkeletonMenu />
                )}
              </nav>
            </div>

            <SidebarLogout
              menuObject={menuObject}
              setMenuObject={setMenuObject}
            />
          </div>
        </div>
      </div>
    </>
  );
};
